import { GameEvent } from "~/business/GameEvent";
import { Spacing } from "~/jsx/theme";
import { XGameCommandEvent } from "./XGameCommandEvent";
import { XGameEventInfo } from "./XGameEventInfo";
import { XPlayerIcon } from "./XPlayerIcon";
import { XPlayerName } from "./XPlayerName";
import { XTypography } from "./XTypography";

const width = 600;

export const XGameEvent = ({ event }: { event: GameEvent }) => {
  let playerPrefix: React.ReactNode | null = null;
  const { game } = event;
  if ("playerId" in event) {
    const { playerId } = event;
    const player = game.getPlayer(playerId);
    playerPrefix = (
      <>
        <XPlayerIcon
          width={18}
          playerId={playerId}
          style={{ marginRight: Spacing.px4 }}
        />{" "}
        <XPlayerName name={player.name} />{" "}
      </>
    );
  }
  const dynamicContent = GameEvent.isGameInfoEvent(event)
    ? XGameEventInfo({ event, game })
    : XGameCommandEvent({ event, game });
  if (dynamicContent === null) return null;

  return (
    <XTypography
      style={{
        padding: Spacing.px8,
        maxWidth: width,
        minWidth: width,
      }}
    >
      {playerPrefix}
      {dynamicContent}
    </XTypography>
  );
};
